
import React, { useState } from 'react';
import { Button, Box, Grid } from '@mui/material';
import DeleteIcon from '@mui/icons-material/Delete';
import { setState, exportTemplate_DataSKU, ImportExcelSKU } from "../scenarioSetupNewSlice";
import { useDispatch, useSelector } from "react-redux";
import CustomButton from '../../../../components/ui/CustomButton';

function BreakdownSKUUpload() {
  const [uploadedSKUFile, setuploadedSKUFile] = useState(null);
  const dispatch = useDispatch();
  const setupState = useSelector((store) => store.scenarioSetupNew);
  const {
    countryID, scenarioName, selectedCountry, selectedPGs
  } = setupState;
  const handleFileUploadSKU = (event) => {
    const fileObj = event.target.files[0];
    setuploadedSKUFile(fileObj);
  };

  const handleDeleteSKU = () => {
    setuploadedSKUFile(null);
  };
  const DownloadTemplateSKU = () => {
    if (selectedCountry.length <= 0) {
      showMessage("Please select a country", "info");
      return;
    }
    else if (scenarioName === undefined || scenarioName === null || scenarioName === "") {
      showMessage("Please select a Scenario Name", "info");
      return;
    }
    else if (selectedPGs <= 0) {
      showMessage("Please select a SKU", "info");
      return;
    }
    else {
      let productsList = [];
      let productGroupsList = [];
      for (let i = 0; i < selectedPGs.length; i++) {
        if (selectedPGs[i].type === "P") {
          let obj = {};
          obj['id'] = selectedPGs[i].id;
          obj['name'] = selectedPGs[i].name;
          productsList.push(obj);
        }
        else if (selectedPGs[i].type === "PG") {
          let obj = {};
          obj['id'] = selectedPGs[i].id;
          obj['name'] = selectedPGs[i].name;
          productGroupsList.push(obj);
        }
        else if (selectedPGs[i].hasOwnProperty("productID")) {
          let obj ={};
          obj['id'] = selectedPGs[i].productID;
          obj['name'] =  selectedPGs[i].name;
          productsList.push(obj);
      }
      else if (selectedPGs[i].hasOwnProperty("productGroupID")){
          let obj ={};
          obj['id'] = selectedPGs[i].productGroupID;
          obj['name'] = selectedPGs[i].productGroupName;
          productGroupsList.push(obj);
      }
      }
      let obj = {
        scenarioId: 0,
        scenarioName: scenarioName, countryId: countryID,
        countryName: selectedCountry, productGroup: productGroupsList,
        product: productsList, isSKUBreakdown: true
      }
      dispatch(exportTemplate_DataSKU(obj));
    }
  }
  const UploadFileSKU = () => {
    if (selectedCountry.length <= 0) {
      showMessage("Please select a country", "info");
      return;
    }
    else if (scenarioName === undefined || scenarioName === null || scenarioName === "") {
      showMessage("Please select a Scenario Name", "info");
      return;
    }
    else if (selectedPGs <= 0) {
      showMessage("Please select a SKU", "info");
      return;
    }
    else {
      dispatch(setState("scenarioExternalDataSourceSKU",[]));
      const formData = new FormData();
      formData.append("file", uploadedSKUFile, uploadedSKUFile.name);
      let recCnt = selectedPGs.length;
      let obj = {
        scenario: scenarioName,
        recCnt: recCnt,
        formData: formData
      }
      dispatch(ImportExcelSKU(obj));
      setuploadedSKUFile(null);
    }
  }
  const showMessage = (message, severity) => {
    dispatch(setState("message", message));
    dispatch(setState("severity", severity));
    dispatch(setState("messageOpen", true));
  };

  return (
    <Box>
      <Box>
        <Grid container spacing={3} style={{ display: "flex", justifyContent: "flex-end", alignItems: "center"}}>
          <Grid item>
            <Box>
              <Button
                sx={{ my: 0.5,  
                  bgcolor: "grey.lighter",
                  color: "#001489",
                  width:"100%",
                  // height: "40px",
                  // fontSize: "14px",
                  boxShadow: "none",
                  "&:hover": {
                    bgcolor: "#001489",
                    color: "white.main",
                    border:"none",
                  },   
                }}
                component="span"
                onClick={DownloadTemplateSKU}
              >
                Download Template
              </Button>
            </Box>
          </Grid>
          <Grid item>
            <Box>
              <input
                type="file"
                accept=".xls"
                onChange={handleFileUploadSKU}
                style={{ display: 'none' }}
                id="fileInputsku"
                onclick="fileInputsku.value = null"
                value=""
              />
              <label htmlFor="fileInputsku">
                <Button
                  sx={{ my: 0.5,  
                    bgcolor: "grey.lighter",
                    color: "#001489",
                    width:"100%",
                    // height: "40px",
                    // fontSize: "14px",
                    boxShadow: "none",
                    "&:hover": {
                      bgcolor: "#001489",
                      color: "white.main",
                      border:"none",
                    },   
                  }}
                  component="span"
                >
                  Select File
                </Button>
              </label>
            </Box>
          </Grid>
          <Grid item>
            <Box>
              <Button
                disabled={uploadedSKUFile==null || uploadedSKUFile == undefined}
                sx={{ my: 0.5,  
                  bgcolor: "grey.lighter",
                  color: "#001489",
                  width:"100%",
                  // height: "40px",
                  // fontSize: "14px",
                  boxShadow: "none",
                  "&:hover": {
                    bgcolor: "#001489",
                    color: "white.main",
                    border:"none",
                  },   
                }}
                component="span"
                onClick={UploadFileSKU}
              >
                Upload
              </Button>
            </Box>
          </Grid>

        </Grid>
      </Box>
      <Grid>
      {uploadedSKUFile && (
        <Box sx={{ mt: 2, borderBottom:0.25, borderColor: "#e0e0e0"}}>
            <div className="file-display" style={{ display: "flex", justifyContent: "space-between", alignItems: "center"}}>
              <span>{uploadedSKUFile.name}</span>
              {/* <Button variant="outlined" onClick={handleDeleteSKU} sx={{ml: 4}}>
              <DeleteIcon /> &nbsp;Delete
              </Button> */}
              <DeleteIcon onClick={handleDeleteSKU} sx={{ cursor: "pointer"}}/> 
            </div>
        </Box>
       )}
      </Grid>
    </Box>
  );
}

export default BreakdownSKUUpload;
